import argon2 from "argon2-browser/dist/argon2-bundled.min.js";

export async function deriveKeyFromPassword(password: string, salt: Uint8Array): Promise<CryptoKey> {
  const res = await argon2.hash({
    pass: password,
    salt,
    time: 3,
    mem: 64 * 1024,
    parallelism: 1,
    hashLen: 32,
    type: argon2.ArgonType.Argon2id,
  });
  const hash = new Uint8Array(res.hash);
  return crypto.subtle.importKey("raw", hash, { name: "AES-GCM" }, false, ["wrapKey", "unwrapKey"]);
}
